//Resource for all field in personalForm, AccountForm and professional Form
//Author : TaiNguyen
//If anything changes, to avoid contacting other schools,
//please enter the command line at the beginning of the change value
//
//This resource apply for schema, field, Field compare

export const CompanyModel = {
  _organisationF: {
    name: '_organisationObject',
    label: 'Organisation Name',
    placeholder: '',
  },
};

export const CompanySiteModel = {
  companySiteF: {
    name: 'companies',
    label: 'Site Name',
    placeholder: '',
  },
};

export const ContactModel = {
  sectionF: {
    name: 'contact',
  },
  emailF: {
    name: 'email',
    label: 'Email',
    placeholder: 'email@example.com',
  },
  phoneMobileF: {
    name: 'phoneMobile',
    label: 'Mobile Phone(*)',
    placeholder: '',
  },
  //HomePhonePrefix not send to server as a field is defined and independent
  //HomePhonePrefix will be merge with home phone and send to server

  _phoneHomePrefixF: {
    name: '_phoneHomePrefix',
  },
  phoneHomeF: {
    name: 'phoneHome',
    label: 'Home Phone(*)',
    placeholder: '',
  },
  _phoneHomeF: {
    name: '_phoneHome',
    label: 'Home Phone(*)',
    placeholder: '',
  },
};

export const PatientModel = {
  sectionF: {
    name: 'patient',
  },
  firstNameF: {
    name: 'firstName',
    label: 'First Name',
    placeholder: '',
  },
  midNameF: {
    name: 'midName',
    label: 'Middle Name',
    placeholder: '',
  },
  surnameF: {
    name: 'surname',
    label: 'Surname',
    placeholder: '',
  },
  dobF: {
    name: 'dob',
    label: 'Date of birth',
    placeholder: 'dd/mm/yyyy',
  },
  genderF: {
    name: 'gender',
    label: 'Gender',
    placeholder: '',
  },
};
